'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.navigation = twentyninetimes.navigation || function () {

	function init() {
		const site_nav = document.getElementById('js-site-nav');

		if ( site_nav ) {
			siteNav(site_nav);
      subMenuToggle(site_nav);
		}
	}

	function siteNav(site_nav) {
		var site_body		= document.body,
			site_header 	= document.querySelector('.site-header'),
			overlay_bg 		= document.querySelector('.site-header__overlay-bg'),
			overlay 		= document.querySelector('.site-header__overlay');

		var toggleLoginBtns = document.querySelectorAll('.js-overlay-toggle.login');
		if ( toggleLoginBtns ) {
			toggleLoginBtns.forEach((loginBtn) => {
				loginBtn.addEventListener('click', (e) => {
					e.stopPropagation();

					var site_nav_item = site_nav.querySelectorAll('.site-nav .primary-nav > .menu-item'),
						i = 0;

					navFunction(site_nav_item, loginBtn, i);
				});
			});
		}

		site_header.addEventListener('click', function(event) {
			event.stopPropagation();

			var btn = event.target.closest('.js-overlay-toggle');
			if ( !btn ) return;

			var site_nav_item = site_nav.querySelectorAll('.site-nav .primary-nav > .menu-item'),
				i = 0;

			navFunction(site_nav_item, btn, i);
		});

		var navFunction = (site_nav_item, trigger, i) => {
			if ( site_body.classList.contains('overlay-active') && !site_body.classList.contains('search-active') && trigger.classList.contains('search') ) {
				site_body.classList.add('search-active');
				site_body.classList.remove('nav-active', 'login-active-1', 'login-active-2');

				document.querySelector('#site-search .site-search__input').focus();

				return;
			}

			if ( site_body.classList.contains('overlay-active') && !site_body.classList.contains('login-active-1') && trigger.classList.contains('login-1') ) {
				site_body.classList.add('login-active-1');
				site_body.classList.remove('nav-active', 'search-active', 'login-active-2');

				document.querySelector('#site-login .site-search__input').focus();

				return;
			}

			if ( site_body.classList.contains('overlay-active') && !site_body.classList.contains('login-active-2') && trigger.classList.contains('login-2') ) {
				site_body.classList.add('login-active-2');
				site_body.classList.remove('nav-active', 'search-active', 'login-active-1');

				document.querySelector('#site-login .site-search__input').focus();

				return;
			}

			if ( !site_body.classList.contains('overlay-active') && !trigger.classList.contains('site-nav-toggle')  ) {

        site_body.classList.add('overlay-active');
        site_body.classList.remove('nav-active');
				trigger.setAttribute('aria-expanded', true);

				// Disable scrolling
				site_body.classList.add('no-scroll');
				bodyScrollLock.disableBodyScroll(overlay);

				if ( trigger.classList.contains('search') ) {
					site_body.classList.add('search-active');

					document.querySelector('#site-search .site-search__input').focus();
				} else if ( trigger.classList.contains('login-1') ) {
					site_body.classList.add('login-active-1');

					document.querySelector('#site-login .site-search__input').focus();
				} else if ( trigger.classList.contains('login-2') ) {
					site_body.classList.add('login-active-2');

					document.querySelector('#site-login .site-search__input').focus();
				} else if ( trigger.classList.contains('login') ) {
					site_body.classList.add('login-active-1');

					document.querySelector('#site-login .site-search__input').focus(); 

				}

				function site_nav_item_timeout(i) {
					setTimeout(function() {
						site_nav_item[i].classList.add('visible');
					}, i*40);
				}

				for (i = 0; i < site_nav_item.length; i++) { 
					site_nav_item_timeout(i);

					var current = site_nav_item[i];

					if ( !current.classList.contains('open') && current.classList.contains('current-menu-ancestor') ) {
						var current_open = current,
							sub_menu = current.querySelector('.sub-menu');
						
						setTimeout(function() {
							sub_menu.style.height = '100%';
							var height = sub_menu.scrollHeight + 'px';
							sub_menu.style.height = '';

							sub_menu.style.height = height;
							current_open.classList.add('open');
						}, 900);
					}
				}

				window.addEventListener('mousemove', bgMouseFollow);

				i = 0;
			} else {
				// function site_nav_item_timeout(i) {
				// 	setTimeout(function() {
				// 		site_nav_item[i].classList.remove('visible');
				// 	}, i*40);
				// }

				// for (i = 0; i < site_nav_item.length; i++) { 
				// 	site_nav_item_timeout(i);

				// 	var current = site_nav_item[i];

				// 	if ( current.classList.contains('open') ) {
				// 		var current_open = current,
				// 			sub_menu = current.querySelector('.sub-menu');
						
				// 		setTimeout(function() {
				// 			sub_menu.style.height = '0px';
				// 			current_open.classList.remove('open');
				// 		}, 1200);
				// 	}
				// }
				
				// i = 0;

				window.removeEventListener('mousemove', bgMouseFollow);

				site_body.classList.remove('overlay-active', 'search-active', 'login-active-1', 'login-active-2');
				trigger.setAttribute('aria-expanded', false);

				// Re-activate scrolling
				site_body.classList.remove('no-scroll');
				bodyScrollLock.enableBodyScroll(overlay);
			}

      if ( trigger.classList.contains('site-nav-toggle') ) {
        if ( !site_body.classList.contains('nav-active') ) {
          site_body.classList.add('nav-active');

          if ( site_body.classList.contains('overlay-active') ) {
            site_body.classList.remove('overlay-active', 'search-active', 'login-active-1', 'login-active-2');
          }
        } else {
          site_body.classList.remove('nav-active');
        }
      }
		}

		const bgMouseFollow = (evt) => {
			const x = -(window.innerWidth / 2 - evt.pageX) / 10;
			const y = -(window.innerHeight / 2 - evt.pageY) / 10;
			
			overlay_bg.style.transform = `translate3d(${-x}px, ${-y}px, 0)`;
		};
	}

  function subMenuToggle(site_nav) {
		var itemsWithChildren = site_nav.querySelectorAll('.menu-item-has-children');

		if ( itemsWithChildren ) {
			itemsWithChildren.forEach((item) => {
				var sub_menu_toggle = item.querySelector('.js-sub-menu-toggle');

				if ( !sub_menu_toggle ) return;
				
				sub_menu_toggle.addEventListener('click', function(e) {
					e.stopPropagation();

					var nav_item = this.parentElement,
						sub_menu = nav_item.querySelector('.sub-menu');

					if ( !nav_item.classList.contains('open') ) {
						sub_menu.style.height = 'auto';
						var height = sub_menu.clientHeight;
						sub_menu.style.height = '0px';

						setTimeout(function () {
							nav_item.classList.add('open');
							sub_menu.style.height = height + 'px';;

							setTimeout(function () {
								if ( nav_item.classList.contains('open') ) {
									sub_menu.style.height = 'auto';
								}
							}, 400);
						}, 10);
					} else {
						var height = sub_menu.clientHeight;
						sub_menu.style.height = height + 'px';

						setTimeout(function () {
							sub_menu.style.height = '0px';
							nav_item.classList.remove('open');			
						}, 10);
					}

				});
			});
		}
	}

	return {
		init : init
	};

}();